// src/pages/_app.tsx
import "@/styles/globals.css";
import type { AppProps } from "next/app";
import { Analytics } from "@vercel/analytics/next";

export default function App({ Component, pageProps }: AppProps) {
  return (
    <>
      <div className="app-root">
        <Component {...pageProps} />
      </div>
      <div className="crt-overlay" />
      <Analytics />
    </>
  );
}
